<cv-save-button [saving]="saving" [isDirty]="isDirtyForm" (saveForm)="onSave()"></cv-save-button>

<div class="datatable-content scrollable-component">
	<cv-multiselect-search
		[required]="true"
		[label]="'Default ClassValuation Organization (The Incoming order will be created on behalf this class organization)'"
		[placeholder]="'Select a branch'"
		[options]="organizationsList"
		[values]="organizationSelected"		
		[optionText]="'name'"
		[optionValue]="'id'"
		[singleSelectMode] = "true"
		(valuesChange)="onBranchSelected($event, 'classOrganization')"
		[getOptionsFunction]="organizationService.getOrganizationsByName"
		*ngIf="optionsReady">
	</cv-multiselect-search>
	<cv-input
		(controlKeyup)="onChangeMarginCap($event)"
		(change)="onChangeMarginCap($event)"
		[value]="defaultConfigModel.defaultMarginCap"
		[label]="'Default Margin Cap'"
		[type]="'number'"
		[min]="0"
	></cv-input>
	<div *ngIf="false">
		<cv-multiselect-search
			[label]="
			'Default Acuity Branch Name (The Incoming order will be created on behalf of this client)'
			"					
			[placeholder]="'Select a branch'"
			[options]="acuityLenderBranchesList"
			[values]="acuityBranchSelected"		
			[optionText]="'title'"
			[optionValue]="'id'"
			[singleSelectMode] = "true"
			(valuesChange)="onBranchSelected($event, 'acuityBranch')"
			[getOptionsFunction]="lenderService.getAcuityLenderBranches"
			*ngIf="optionsReady">
		</cv-multiselect-search>
		<cv-multiselect-search
			[label]="
				'Default Appscope Client (The Incoming order will be created on behalf of this client in appscope. let empty and the system will use the lender configuration strategic based on the acuity branch mappers)'
			"					
			[placeholder]="'Select an Appscope client'"
			[options]="appScopeLendersList"
			[values]="clientBranchSelected"		
			[optionText]="'title'"
			[optionValue]="'id'"
			[singleSelectMode] = "true"
			(valuesChange)="onBranchSelected($event, 'appscopeClient')"
			[getOptionsFunction]="lenderService.getLenders"
			*ngIf="optionsReady">
		</cv-multiselect-search>
		<cv-input
			(controlKeyup)="defaultConfigModel.defaultAppScopeUserCreation = $event.value.trim()"
			[value]="defaultConfigModel.defaultAppScopeUserCreation"
			[label]="
				'Default Appscope User Creation (This username is required to consume the appscope api. Represents who ordered the order.)'
			"
			[type]="'text'"
			[name]="'defaultSettings'"
			[minlength]="1"
			[placeholder]="'appscope user name'"
		></cv-input>
		<div class="callCenter-title">
			<h3 >FNC Client Configuration</h3>
			<button class="btn btn-sm cv-btn-blue"
			(click)="addClient()">Add New Client
			</button>
		</div>
		<ag-grid-angular
			#grid
			class="ag-theme-balham"
			[enableCellTextSelection]="true"
			(gridReady)="onInitializeGrid($event)"
			(gridSizeChanged)="resizeToFitColumns()"
			[pagination]="true"
			[suppressPaginationPanel]="true"
			[gridOptions]="gridOptions"
			[domLayout]="'autoHeight'"
			[rowData]="gridData"
		>
		</ag-grid-angular>
	</div>
</div>
